/**
 * Find Account Store
 *
 * @author minkyoung.park@emcast.com
*/
// states
const state = {
    step1: {
        value: '',
        firstName: '',
        lastName: '',
        code: '',
        
    },
    authMethods: [],
    step2: {
        findWay: '',
        value: '',
    },
    step3: {
        value: '',
        token: '',
    },
    loginId: ''
}

// getters
const getters = {}

// mutations
const mutations = {
    INIT_FINDID_STORE(state) {
        state.step1.value = ''
        state.step1.firstName = ''
        state.step1.lastName = ''        
        state.step1.code = ''
        
        state.authMethods = []
        
        state.step2.findWay = ''
        state.step2.value = ''

        state.step3.value = ''
        state.step3.token = ''
        
        state.loginId = ''
    },

    SET_STEP1(state, value) {
        state.step1 = value
    },

    SET_STEP2(state, value) {
        state.step2 = value
    },

    SET_STEP3(state, value) {
        state.step3 = value
    },

    SET_AUTH_METHODS(state, value) {
        state.authMethods = value
    },

    SET_STEP1_VALUE(state, value) {
        state.step1.value = value
    },

    SET_TOKEN(state, value) {
        state.token = value
    },

    SET_LOGINID(state, value) {
        state.loginId = value
    },
}

// actions
const actions = {
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}